// src/context/AppContext.js
import React, { createContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { customFetch } from "../helper/api-helper/apiHerlpers";
import { format } from "react-string-format";
import apiUrls from "../constants/apiUrls";
import { useKeycloakState } from "./KeycloakContext";

const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const { kc, kcInitialized } = useKeycloakState();

  const [applicationId, setApplicationId] = useState(
    Number(localStorage.getItem("applicationid")) || null
  );
  const [siteId, setSiteId] = useState(
    Number(localStorage.getItem("siteid")) || null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppSite = async () => {
      if (!kc || !kc.token) return;

      try {
        const domainName = window.location.hostname;
        const url = format(apiUrls.GetSiteId, domainName);

        const res = await customFetch(url, kc.token);

        if (res?.applicationId && res?.siteId) {
          setApplicationId(res.applicationId);
          setSiteId(res.siteId);

          // 🔑 persist globally for apiCommonParams
          localStorage.setItem("applicationid", res.applicationId);
          localStorage.setItem("siteid", res.siteId);
        } else {
          toast.error("Failed to fetch application/site info");
        }
      } catch (err) {
        console.error("Error fetching application/site:", err);
        toast.error("Error fetching application/site info");
      } finally {
        setLoading(false);
      }
    };

    if (kcInitialized) fetchAppSite();
  }, [kc, kcInitialized]);

  return (
    <AppContext.Provider
      value={{
        applicationId,
        siteId,
        loading
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
